import { useEffect } from "react";

const CleverTapNotifications = () => {
  useEffect(() => {
    if (typeof window === "undefined" || !window.clevertap) return;

    const lastShown = localStorage.getItem("ct_notification_last_shown");
    const oneMonth = 30 * 24 * 60 * 60 * 1000;

    if (!lastShown || Date.now() - Number(lastShown) > oneMonth) {
      window.clevertap.notifications.push({
        titleText: "Stay informed!",
        bodyText: "Would you like to receive push notifications?",
        okButtonText: "Notify me",
        rejectButtonText: "No thanks",
        okButtonColor: "#0363C4",
        serviceWorkerPath: "/clevertap_sw.js",
      });

      localStorage.setItem(
        "ct_notification_last_shown",
        Date.now().toString()
      );
    }
  }, []);

  return null;
};

export default CleverTapNotifications;
